import React, { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'

/* eslint-disable react-hooks/exhaustive-deps, @typescript-eslint/no-unused-expressions */

import _ from 'lodash'

import useMediaQuery from 'hooks/useMediaQuery'

import { Segment, Container, Grid } from 'semantic-ui-react'
import { mergeStyles } from '@enlyt/helpers/mergeStyles'

import { useTheme } from 'contexts/ThemeProvider'

import themeStyles from './styles'
import localization from './localization'

import GlanceItems from './items'

import UpcomingVisitsWidget from 'components/Tiles/UpcomingVisitsWidget'

import {
  getCheckinLoading,
  getApptsOfCheckinLoading
} from 'stores/Appointments/Select'

import { getCurPatientData, getCurPatientId } from '@web/stores/Account/Select'
import useMyHealthPolicyByModel from 'hooks/useMyHealthPolicy'
import AppointmentsDataLoader from 'components/Appointments/AppointmentsDataLoader'
import withLocalization from '@web/helpers/localizationUtils'
import { useGetUpcomingAppointments } from '@web/hooks/api/appointments'

export const InformationAtGlance = props => {
  const { style, setAdolescent, t } = props
  const { theme } = useTheme()
  const defaultStyles = themeStyles(theme)
  const styles = mergeStyles(defaultStyles, style)
  const { isMobile, isTablet } = useMediaQuery()
  const isMedicationsAllowable = !useMyHealthPolicyByModel('medications')
  const isTestResultsAllowable = !useMyHealthPolicyByModel('medications')
  const isAdolescent = isMedicationsAllowable && isTestResultsAllowable

  const columns = useMemo(() => {
    return isMobile || isTablet ? 1 : 3
  }, [isMobile, isTablet])

  const patientDetails = useSelector(getCurPatientData)
  const isUser = _.get(patientDetails, 'isUser', false)
  const patientId = useSelector(getCurPatientId)
  const token = useSelector(state => state.auth.user.idToken)

  const upcoming = useGetUpcomingAppointments({
    patientId,
    token,
    dependentAccount: patientDetails
  })

  const upcomingAppointmentsList = useMemo(
    () => upcoming.data?.appointmentLookup?.appointments ?? [],
    [upcoming.data]
  )

  const uncomingContainer = isMobile
    ? styles.noPadding
    : !isTablet
      ? styles.uncomingContainer
      : {}
  const itemContainer = isMobile
    ? styles.noPadding
    : !isTablet
      ? styles.medicationsContainer
      : {}

  const currCheckinAppointmentId = useSelector(getApptsOfCheckinLoading)
  const loadingCheckin = useSelector(getCheckinLoading)
  const upcomingAppointmentsLoading = upcoming.isLoading

  useEffect(() => {
    setAdolescent && setAdolescent(isAdolescent)
  }, [isAdolescent])

  return (
    <div style={styles.informationAtGlanceArea}>
      <div style={styles.barTitle}>{t('information_at_glance_title')}</div>
      <div>
        <Segment vertical>
          <Container>
            {isUser ? (
              <AppointmentsDataLoader />
            ) : (
              patientId && <AppointmentsDataLoader />
            )}
            <Grid columns={columns}>
              <Grid.Column key='upcoming' style={uncomingContainer}>
                <UpcomingVisitsWidget
                  loadingCheckin={loadingCheckin}
                  currCheckinAppointmentId={currCheckinAppointmentId}
                  errorUpcomingAppointments={upcoming.isError}
                  loading={upcomingAppointmentsLoading}
                  latestUpcomingAppointments={upcomingAppointmentsList}
                  style={styles}
                  linkTo='/appointments'
                />
              </Grid.Column>
              {GlanceItems.map((item, index) => (
                <Grid.Column key={index} style={itemContainer}>
                  <item.Component
                    Content={item.content}
                    adolescent={isAdolescent}
                  />
                </Grid.Column>
              ))}
            </Grid>
          </Container>
        </Segment>
      </div>
    </div>
  )
}

export default withLocalization(InformationAtGlance, localization)
